<template>
  <create-manager edit="true" @edit="edit = false"/>
  
</template>

<script>
import CreateManager from '@/components/ManageUsers/CreateManager';
export default {
    components:{
        CreateManager
    },
    props:{
      uid:{
        require: false
      }
    },
    computed:{
      uId:{
        get(){
          return this.uid;
        }
      }
    }
}
</script>

<style>

</style>